module.exports = __webpack_public_path__ + "img/icon-product-active.40682809.svg";